import { create } from 'zustand';

export interface ShareLinkDialogContext {
  objectId?: string;
  type?: string; // 'playlist' | 'folder'
  subType?: string;
  name?: string;
}

interface ShareLinkDialogState {
  isOpen: boolean;
  dialogContext: ShareLinkDialogContext;
  openShareLinkDialog: (context: ShareLinkDialogContext) => void;
  closeShareLinkDialog: () => void;
}

export const useShareLinkDialogStore = create<ShareLinkDialogState>((set) => ({
  isOpen: false,
  dialogContext: {},
  openShareLinkDialog: (dialogContext) => set({ isOpen: true, dialogContext }),
  closeShareLinkDialog: () => set({ isOpen: false, dialogContext: {} }),
}));
